import React, { Suspense   } from "react" ;
import { Routes, Route } from "react-router-dom";

//Layouts
import Layout from "../Layouts/index";
import Fullscreen from "../Layouts/Fullscreen";
//routes
import { publicRoutes } from "./allRoutes";

const Index = () => {
  return (
    <React.Fragment>
        <Suspense>
          <Routes>
            <Route>
              {publicRoutes.map((route, idx) => (
                <Route
                  path={route.path}
                  element={(route.fullscreen ==="Y") ? <Fullscreen>{route.element || route.component}</Fullscreen> : <Layout>{route.element || route.component}</Layout> }
                  key={idx}
                  exact={true}
                />
              ))}
            </Route>
          </Routes>
        </Suspense>
    </React.Fragment>
  );
};

export default Index;
